module.exports = __webpack_public_path__ + "img/afrihost.d7251f11.png";